export interface LoadingStateProps {
  label?: string;
}

export function LoadingState({ label = 'Loading…' }: LoadingStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      style={{ padding: '2rem', color: 'var(--color-muted)', textAlign: 'center' }}
    >
      {label}
    </div>
  );
}
